/** DVA namespace — must match `model.js`. */
export const MODEL_NAME = 'financialAdministration';

/** Fixed hub API. Not emitted as a GET /me/navigation section item. */
export const API_ROUTE = 'channel/financial-administration';

/** Customer discount catalog used only to explain a stored assignment. */
export const CUSTOMER_DISCOUNTS_API_ROUTE = 'billing/customer-discounts';

export const FINANCIAL_ADMINISTRATION_PATH = '/configuration/financial-administration';

export const TAB_KEYS = Object.freeze({
  OVERVIEW: 'overview',
  PAYMENTS: 'payments',
  LEDGERS: 'ledgers',
  SETTLEMENTS: 'settlements',
  BENEFICIARY: 'beneficiary',
});

export const DEFAULT_PAGE_SIZE = 5;
export const MAX_PAGE_SIZE = 500;

export const DETAIL_KIND = Object.freeze({
  PAYMENT: 'payment',
  LEDGER: 'ledger',
  SETTLEMENT: 'settlement',
});
